"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));

var _material = require("@mui/material");

var _usePlaceholders2 = require("../../hooks/usePlaceholders/usePlaceholders");

var rPlaceholderMarker = /\[|\]]/g;
var styles = {
  text: {
    '& > span': {
      backgroundColor: 'yellow.sunflower50'
    }
  }
};

var TextWithPlaceholders = function TextWithPlaceholders(_ref) {
  var text = _ref.text,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? [] : _ref$sx;

  var _usePlaceholders = (0, _usePlaceholders2.usePlaceholders)(),
      placeholders = _usePlaceholders.placeholders;

  var rAllPlaceholders = (0, _react.useMemo)(function () {
    return new RegExp(placeholders.map(function (placeholder) {
      return "(".concat(placeholder.value.replaceAll(rPlaceholderMarker, function (marker) {
        return "\\".concat(marker);
      }), ")");
    }).join('|'), 'gm');
  }, [placeholders]);
  var html = (0, _react.useMemo)(function () {
    var sanitized = (0, _sanitizeHtml.default)(text);
    return sanitized.replaceAll(rAllPlaceholders, function (placeholder) {
      return "<span>".concat(placeholder, "</span>");
    });
  }, [text, rAllPlaceholders]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: [styles.text].concat((0, _toConsumableArray2.default)(Array.isArray(sx) ? sx : [sx])),
    component: "span",
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
};

var _default = TextWithPlaceholders;
exports.default = _default;